import { PaymentTypeEnum, PricingQuoteIncludedProductDto, ProductTypeEnum, TieredFeeTypeEnum } from '@inosio/payments-sdk';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';

export interface PricingQuoteFootNotesProps {
  /**
   * A list of products included in this quote.
   */
  includedProducts: PricingQuoteIncludedProductDto[];

  /**
   * The discount on this quote.
   */
  packageDiscount?: number;
}

export const PricingQuoteFootNotes = (props: PricingQuoteFootNotesProps) => {
  const paymentsProduct = props.includedProducts.find((prod) => prod.ProductType === ProductTypeEnum.Payments);
  const dbConfig = paymentsProduct?.PaymentOptions?.find((config) => config.PaymentType === PaymentTypeEnum.Db);
  const dbPerc = dbConfig?.Fee.find((fee) => fee.FeeType === TieredFeeTypeEnum.P)?.Amount;

  const footNotesConfig = [
    {
      condition: props.packageDiscount && props.packageDiscount > 0,
      text: '* Must maintain minimum utilization as mentioned above',
    },
    {
      condition: !!paymentsProduct && !!dbPerc,
      text: `† Debit card fees are ${((dbPerc || 0) / 10).toFixed(1)}% for transactions $2500+`,
    },
    {
      condition: props.includedProducts?.some((prod) => prod.ConsumableFee && prod.ProductType === ProductTypeEnum.Applications),
      text: '‡ Application processing fee is waived when applicant is screened via Inosio.',
    },
    {
      condition: true,
      text: '§ All rates are subject to final review and approval by Inosio. Pricing is provided as a general estimate and may be adjusted at our discretion. Inosio reserves the right to correct any errors or discrepancies in pricing at any time.',
    },
  ];

  const footNotes = footNotesConfig.filter((note) => note.condition); // Include only valid notes
  return (
    <Box sx={{ textAlign: 'left', width: '80%' }}>
      {footNotes.map((note, index) => (
        <Typography key={index} sx={{ fontFamily: 'Work Sans !important', fontSize: '14px', mb: 1 }}>
          {note.text}
        </Typography>
      ))}
    </Box>
  );
};

export default PricingQuoteFootNotes;
